import { render } from "./settings.vue?vue&type=template&id=71c1bcf2"
import script from "./settings.vue?vue&type=script&lang=js"
export * from "./settings.vue?vue&type=script&lang=js"

import "./settings.vue?vue&type=style&index=0&id=71c1bcf2&lang=scss"
script.render = render

export default script